<nb-card>
  <nb-card-body>
    <div id="print-section" class="print-layout">
      <div *ngIf="shop.coverUrl" class="logo-bill">
        <img width="100" [src]="shop.coverUrl" alt="" />
      </div>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td style="text-align: center">
            <h4>{{ shop.title }}</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              {{ shop.address }}
            </label>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              ĐT: {{ shop.mobile }}
              <span *ngIf="shop.email"> - Email: {{ shop.email }} </span>
              <span *ngIf="shop.website"> - Web: {{ shop.website }} </span>
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <h4 *ngIf="finance.isReceive">PHIẾU THU</h4>
            <h4 *ngIf="!finance.isReceive">PHIẾU CHI</h4>
          </td>
        </tr>
        <tr>
          <td style="text-align: center">
            <label>
              Ngày:
              {{ finance.issueDate | date : "dd/MM/yyyy " }}
            </label>
          </td>
        </tr>
        <tr *ngIf="finance.id.length > 6">
          <td style="text-align: center">
            <label>
              {{ "common.code" | translate }}:
              {{ finance.id.substring(finance.id.length - 6, 6) }}
            </label>
          </td>
        </tr>

        <tr>
          <td class="height-1"></td>
        </tr>
      </table>

      <table width="100%" class="table-detail">
        <tr>
          <td style="text-align: left">
            <strong *ngIf="finance.isReceive"> Người gửi </strong>
            <strong *ngIf="!finance.isReceive"> Người nhận </strong>
          </td>
          <td style="text-align: left">
            {{
              finance.personName
                ? finance.personName
                : finance.isReceive
                ? finance.customerName
                : finance.supplierName
            }}
          </td>
        </tr>

        <tr>
          <td style="text-align: left">
            <strong> Điện thoại </strong>
          </td>
          <td style="text-align: left">
            {{ finance.personMobile }}
          </td>
        </tr>
        <tr>
          <td style="text-align: left">
            <strong> {{ "common.address" | translate }} </strong>
          </td>
          <td style="text-align: left">
            {{ finance.personAddress }}
          </td>
        </tr>

        <tr>
          <td style="text-align: left">
            <strong> {{ "common.note" | translate }} </strong>
          </td>
          <td style="text-align: left" class="note">
            {{ finance.note }}
          </td>
        </tr>

        <tr *ngIf="finance.groupName">
          <td style="text-align: left">
            <strong> Phân nhóm </strong>
          </td>
          <td style="text-align: left">
            {{ finance.groupName }}
          </td>
        </tr>

        <tr>
          <td style="text-align: left">
            <strong> Số tiền </strong>
          </td>
          <td style="text-align: left">
            <h2 *ngIf="finance.isReceive">
              {{ finance.receiveAmount | number : 0 }}
            </h2>
            <h2 *ngIf="!finance.isReceive">
              {{ finance.issueAmount | number : 0 }}
            </h2>
          </td>
        </tr>
        <!-- <tr>
          <td style="text-align: left">
            <strong> Bằng chữ </strong>
          </td>
          <td style="text-align: left">
            {{ numToText }}
          </td>
        </tr> -->
      </table>

      <table width="100%" cellpadding="0" cellspacing="0" class="table-header">
        <tr>
          <td colspan="3" class="height-1"></td>
        </tr>

        <tr>
          <td style="text-align: center">
            <strong> Người lập phiếu </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong *ngIf="finance.isReceive"> Người gửi </strong>
            <strong *ngIf="!finance.isReceive"> Người nhận </strong>
            <br />
            <span> (Ký, họ tên) </span>
          </td>

          <td style="text-align: center">
            <strong> Kế toán trưởng </strong> <br />
            <span> (Ký, họ tên) </span>
          </td>
        </tr>
      </table>
    </div>
  </nb-card-body>
</nb-card>
